const defaultInstallmentForm = {
    id: '',
    initial_price: null,
    month_price: null,
    final_price: null,
    object_id: '',
    tariff_name: '',
    terminal__id: '', 
    terminal__name: '',
    installment_type: '',
    is_active: false,
    created_on: '',
    updated_on: ''
}

export default defaultInstallmentForm;